import Ember from 'ember';
import Service from '@ember/service';
import { get, hasKey, t, tSplit, setCapabilityChecker, setEscapingFunction, setup } from 'i18n';

/**
 * @typedef {Object<string,string|StringTree>} StringTree
 */

export default class I18nService extends Service {
  configure(userInfo, language, features) {
    // Configure `i18n` to escape regular strings when interpolating.
    setEscapingFunction(Ember.Handlebars.Utils.escapeExpression);
    setCapabilityChecker({
      hasCapability(capability) {
        return userInfo.get(capability) || features[capability];
      }
    });
    setup({
      currentCountry: userInfo.countryCode,
      currentLocale: language
    });
    this.countryCode = userInfo.countryCode;
  }
  setup(options) {
    setup(options);
  }

  /**
   * @param {string} key an i18n key, e.g. "common.title"
   * @param {object=} values interpolated values for placeholders
   * @returns {string}
   */
  t(key, values = {}) {
    return t(key, values);
  }

  /**
   * @param {string} key a full or partial i18n key, e.g. "common"
   * @returns {StringTree}
   */
  get(key) {
    return get(key);
  }

  /**
   * @param {string} key an i18n key, e.g. "common.title"
   * @returns {boolean}
   */
  hasKey(key) {
    return hasKey(key);
  }

  /**
   * @param {string} key an i18n key, e.g. "common.title"
   * @param {object=} binding
   */
  tSplit(key, binding) {
    return tSplit(key, binding);
  }
}